import SDK from '../sdk/utils'

function makeQuery (data) {
  return '?' + Object.keys(data).map(key => `${key}=${data[key]}`).join('&')
}

function getUrl (data) {
  return `${window.location.protocol}//goods.iciba.com/api/vip/list${makeQuery(data)}`
}

export async function getVipInfo (oversea) {
  // 用户信息，签名
  const userInfo = await SDK.getUserInfo()
  const args = await SDK.signature({
    c: 'vip',
    m: 'vip_list_new',
    token: userInfo.token,
    oversea
  })
  return fetch(getUrl(args), {
    headers: {
      'cbAuthorization': userInfo.token
    }
  })
    .then(res => res.json())
}